module.exports = __webpack_public_path__ + "img/h6.517812c4.jpg";